import { ScLanguage } from "~/store/ui/environment/environment.types"

export function getSitecoreLocaleTranslation (code: string | undefined, scLanguages: ScLanguage[]): string {
  const match = scLanguages.find(({ language }) => {
    const scCode = language && language.targetItem && language.targetItem.code
    return code === scCode
  })

  return match && match.languageTitle && match.languageTitle.value || ''
}
